<template>
  <div class="w-full px-5">
    <el-row :gutter="20" class="mb-4">
      <el-col :xs="24" :sm="12">
        <el-form-item prop="name">
          <label class="text-sm block">Name:</label>
          <el-input class="w-full" v-model="form.name" type="text"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item prop="shipper_id">
          <label class="text-sm block">Shipper:</label>
          <el-select class="w-full" v-model="form.shipper_id" placeholder="Please select...">
            <el-option
              v-for="shipper in shippers"
              :key="shipper.id"
              :label="shipper.name"
              :value="shipper.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="mb-4">
      <el-col :xs="24" :sm="12">
        <el-form-item prop="delivery_max_miles">
          <label class="text-sm block">Delivery max. miles:</label>
          <el-input class="w-full" v-model="form.delivery_max_miles" type="number"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item prop="delivery_init_miles">
          <label class="text-sm block">Delivery initial mile:</label>
          <el-input class="w-full" v-model="form.delivery_init_miles" type="number"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="mb-4">
      <el-col :xs="24" :sm="12">
        <el-form-item prop="delivery_init_mile_cost">
          <label class="text-sm block">Delivery initial mile cost:</label>
          <el-input class="w-full" v-model="form.delivery_init_mile_cost" type="number"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item prop="delivery_additional_mile_cost">
          <label class="text-sm block">Delivery additional mile cost:</label>
          <el-input class="w-full" v-model="form.delivery_additional_mile_cost" type="number"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="mb-4">
      <el-col :xs="24" :sm="12">
        <el-form-item prop="free_delivery_max_miles">
          <label class="text-sm block">Free delivery max. miles:</label>
          <el-input class="w-full" v-model="form.free_delivery_max_miles" type="number"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12">
        <el-form-item prop="free_delivery_min_amount">
          <label class="text-sm block">Free delivery minimum amount:</label>
          <el-input class="w-full" v-model="form.free_delivery_min_amount" type="number"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="mb-4">
      <el-col :xs="12" :sm="12">
        <el-form-item prop="default">
          <label class="text-sm block">Default</label>
          <el-switch v-model="form.default"></el-switch>
        </el-form-item>
      </el-col>
      <el-col :xs="12" :sm="12">
        <el-form-item prop="status">
          <label class="text-sm block">Enable</label>
          <el-switch v-model="form.status"></el-switch>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'DeliveryMethodForm',
  props: ['form'],
  computed: {
    shippers() {
      return this.$store.state.InventoryModule.Shippers.shippers;
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch('InventoryModule/Shippers/fetchAllShippers');
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
  },
};
</script>

<style scoped>

</style>
